export default "__VITE_ASSET__DeDo0nZi__"